"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventSenderBase = void 0;
const constants_1 = require("../constants");
class EventSenderBase {
    sendEvent(eventData) {
        fetch(this.url, {
            ...constants_1.POST_FETCH_CONFIG,
            body: JSON.stringify(eventData),
        })
            .then((response) => {
            if (!response.ok) {
                console.error("Links and Buttons - Fetch error in sending event: " + response.statusText + " " + response.status);
            }
        })
            .catch((error) => {
            console.error("Links and Buttons - Error in sending event: " + error?.toString());
        });
    }
}
exports.EventSenderBase = EventSenderBase;
